export const CReferralsIcon = 'icons/payments.svg' as const;

export const CReferralStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    INVALID: 'INVALID'
} as const
export const CInvalidReferralCode ='invalidReferralCode';